import { render, staticRenderFns } from "./ScanToSeeMenuText.vue?vue&type=template&id=5c15761a&scoped=true&"
import script from "./ScanToSeeMenuText.vue?vue&type=script&lang=js&"
export * from "./ScanToSeeMenuText.vue?vue&type=script&lang=js&"
import style0 from "./ScanToSeeMenuText.vue?vue&type=style&index=0&id=5c15761a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c15761a",
  null
  
)

export default component.exports